import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const itemPriceService = {
  getAllItemPrices,
  getItemPriceByItem,
  createItemPrice,
}

const API_URL = API.BASE_URL + '/v1'

function buildParams(filter) {
  const params = { page: filter?.pageNumber, size: filter?.pageSize }
  if (filter?.itemCode) params.item_code = filter.itemCode
  filter?.searchArray?.forEach((w, i) => {
    if (w !== null && w !== '') params[`search_words[${i}]`] = w
  })
  return params
}

export function getAllItemPrices(filter) {
  return apiHelper(API_URL).get('/item-prices', { params: buildParams(filter) })
}
export function getItemPriceByItem(itemCode) {
  return apiHelper(API_URL).get(`/item-prices/${itemCode}`)
}
export function createItemPrice(data) {
  return apiHelper(API_URL).post('/item-prices', data)
}
